import _ from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { workspacesSelectors } from '../redux/slices/workspaces';

const getWorkspaceLoadingFromStore = (state) => state.workspaces.loading;
const getInvitationToWorkspaceFromStore = (state) =>
  state.invitations.currentInvitation;

export const hasWorkspaces = (state) =>
  workspacesSelectors.selectTotal(state) > 0;

export const getWorkspaces = createSelector(
  workspacesSelectors.selectAll,
  (state) => state.workspaces.invitations,
  (workspaces, guestWorkspaces) => [...workspaces, ...guestWorkspaces]
);

export const getWorkspaceById = (id) => (state) =>
  workspacesSelectors.selectById(state, id);

export const getSuperAdminLookup = (state) => state.workspaces.superAdminLookup;

// loaders
export const isWorkspaceLoading = () =>
  createSelector(
    getWorkspaceLoadingFromStore,
    (loadingWorkspace) => !!loadingWorkspace
  );

// invitation selectors
export const cameFromInvitation = () =>
  createSelector(
    getInvitationToWorkspaceFromStore,
    (invitationWorkspace) => !_.isEmpty(invitationWorkspace)
  );

export const getInvitationToken = () =>
  createSelector(
    getInvitationToWorkspaceFromStore,
    (invitationWorkspace) => invitationWorkspace.token
  );

export const getInvitationInfo = () =>
  createSelector(
    getInvitationToWorkspaceFromStore,
    (invitationWorkspace) => invitationWorkspace
  );

export const hasWorkspacesInvitations = createSelector(
  (state) => state.workspaces.invitations,
  (invitations) => invitations.length > 0
);
